import React from 'react';
import Header from 'components/Header';
import UserStore from 'components/UserStore';
import request from '../../../utils/agent';
import UserMenu from './Menu';
import './User.scss';


export default class UserTemplate extends React.Component {
    constructor (props) {
        super(props);

        this.state = {
            userIsValid: UserStore.isLoggedIn(),
            userData : {},
            userCData: {},
            userRole : {},
            userTrainings: {},
            loaded: false,
        }
    }

    // When loading the UserTemplate, lets grab all the User Data
    async componentDidMount() {
        if(!this.state.userIsValid) {
            let userIsValid = await this.getUserData();
            this.setState({userIsValid});
        }
        // this.geCData();
        // this.getRoleData();
        // this.getTrainingData();
        window.addEventListener('trainingCompleted', () => {
            location.reload();
        })
    }

    getUserData = async () => {
        return new Promise((resolve, reject) => {
            request.get('/api/user')
                .then(resp => {
                    UserStore.add(resp.body.user);
                    this.setState({
                        userData: resp.body.user,
                        userCData: resp.body.user.cdata,
                        userRole: resp.body.user.role,
                        userTrainings: resp.body.user.trainings,
                        loaded: true
                    });
                    resolve(true);
                });

        });
    };

    /*geCData = async () => {
        return new Promise((resolve, reject) => {
            request.get('/api/user')
                .then(resp => {
                    this.setState({
                        userCData: resp.body.user.cdata,
                        loaded: true
                    });
                    resolve(true);
                });

        });
    };

    getRoleData = async () => {
        return new Promise((resolve, reject) => {
            request.get('/api/user')
                .then(resp => {
                    this.setState({userRole: resp.body.user.role});
                    resolve(true);
                });

        });
    };

    getTrainingData = async () => {
        return new Promise((resolve, reject) => {
            request.get('/api/user')
                .then(resp => {
                    this.setState({userTrainings: resp.body.user.trainings});
                    resolve(true);
                });

        });
    };*/


    render() {

        if(!this.state.userIsValid) {
            return null;
        }

        //console.log('tr st', this.state.userTrainings);

        let trainingFlag = false;

        if (this.state.userTrainings.length > 0) {
            const latestTraining = this.state.userTrainings.length-1;
           // console.log('last tr', latestTraining);
            if(this.state.userTrainings[latestTraining].percent >= 80) {
                trainingFlag = true;
            }
        }




        return (
            <div className="user-dashboard">
                <Header />
                <div className="user_container clearfix">
                    {this.state.loaded?
                        <UserMenu
                            role={this.state.userRole.name}
                            name={`${this.state.userCData.first_name} ${this.state.userCData.last_name}`}
                            trainingStat={trainingFlag}
                            agreementStat={this.state.userCData.agreement_status}
                            resellerAgreementStat={this.state.userCData.reseller_agreement_status}
                        />:
                        <UserMenu
                            role={this.state.userRole.name}
                            name=""
                            trainingStat={trainingFlag}
                        />
                    }
                    <div className="user_content col-md-10">
                        {this.props.children}
                    </div>
                </div>

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Templates/User/index.js